import { render, staticRenderFns } from "./AddPersonnel.vue?vue&type=template&id=11d59bdd&"
import script from "./AddPersonnel.vue?vue&type=script&lang=js&"
export * from "./AddPersonnel.vue?vue&type=script&lang=js&"
import style0 from "./AddPersonnel.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports